export default __webpack_public_path__ + "static/beach-bamburgh-0a1a02274803fe40ae70e160befb8a32.jpg";